import { CT_APP_PACKAGE_NAME, CLASSTING_URL } from '@/config';
import './web2App';

// eslint-disable-next-line import/prefer-default-export
export function setDeepLink(urlScheme = 'classting://') {
  const ua = window.daumtools.userAgent();
  const storeURL = ua.os.android ? 'market://details?id=com.Classting' : 'http://goo.gl/88kSr';

  window.daumtools.web2app({
    urlScheme,
    intentURI: `intent://classInvitation/A#Intent;scheme=classting;package=${CT_APP_PACKAGE_NAME};end;`,
    appName: 'Classting',
    storeURL,
    onUnsupportedEnvironment: () => {
      window.open(CLASSTING_URL, '_blank');
    },
  });
}
